import { render, staticRenderFns } from "./Microship.vue?vue&type=template&id=15952f6c&"
import script from "./Microship.vue?vue&type=script&lang=js&"
export * from "./Microship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports